import React, { useState } from "react";
import { Share2, Check, Copy } from "lucide-react";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "./ui/dropdown-menu";
import { toast } from "sonner";

const NETS = [
  { key: "whatsapp", label: "WhatsApp", url: (u, tx) => `https://wa.me/?text=${encodeURIComponent(tx + " " + u)}` },
  { key: "linkedin", label: "LinkedIn", url: (u) => `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(u)}` },
  { key: "facebook", label: "Facebook", url: (u) => `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(u)}` },
  { key: "x", label: "X", url: (u, tx) => `https://twitter.com/intent/tweet?text=${encodeURIComponent(tx)}&url=${encodeURIComponent(u)}` },
  { key: "telegram", label: "Telegram", url: (u, tx) => `https://t.me/share/url?url=${encodeURIComponent(u)}&text=${encodeURIComponent(tx)}` },
];

export function ShareMenu({ url, text = "Check this out on GetJobs.Today", label = "Share", testid = "share-menu" }) {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    await navigator.clipboard.writeText(url);
    setCopied(true);
    toast.success("Link copied");
    setTimeout(() => setCopied(false), 2000);
  };
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button data-testid={`${testid}-trigger`} className="inline-flex items-center gap-2 rounded-xl border border-slate-200 px-4 py-2 text-sm font-semibold text-navy hover:bg-brand-bluelight transition-colors">
          <Share2 className="h-4 w-4" /> {label}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48">
        {NETS.map((n) => (
          <DropdownMenuItem key={n.key} data-testid={`${testid}-${n.key}`} onClick={() => window.open(n.url(url, text), "_blank")}>
            {n.label}
          </DropdownMenuItem>
        ))}
        <DropdownMenuItem data-testid={`${testid}-copy`} onClick={copy}>
          {copied ? <Check className="h-4 w-4 mr-2" /> : <Copy className="h-4 w-4 mr-2" />} Copy link
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
